module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workflow-content"
  }, [_c('edit-workflow', {
    attrs: {
      "row-data": _vm.rowData,
      "site-id": _vm.siteId
    }
  }), _vm._v(" "), (_vm.rowData.totalFiles > 0) ? _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('h3', [_vm._v("Files")])]), _vm._v(" "), _c('good-table', {
    attrs: {
      "cols": [{
        label: 'File Name',
        field: 'file'
      }, {
        label: 'Party No.',
        field: 'partyNo'
      }],
      "rows": _vm.rowData.requiredFiles.files
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('checklist-table', {
    attrs: {
      "parent-data": _vm.rowData
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e24493c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/WorkflowDetails.vue
// module id = 1557
// module chunks = 0